import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function AWSCredentials() {
    return (
        <React.Fragment>
            <p>
                Ensure that the user associated with the AWS access key has the following object and bucket operation
                permissions:
            </p>
            <ul>
                <li>
                    {' '}
                    <code className="language-text">AbortMultipartUpload</code>
                </li>
                <li>
                    {' '}
                    <code className="language-text">DeleteObject</code>
                </li>
                <li>
                    {' '}
                    <code className="language-text">GetObject</code>
                </li>
                <li>
                    {' '}
                    <code className="language-text">ListBucket</code>
                </li>
                <li>
                    {' '}
                    <code className="language-text">ListMultipartUploadParts</code>
                </li>
                <li>
                    {' '}
                    <code className="language-text">PutObject</code>
                </li>
                <li>
                    {' '}
                    <code className="language-text">GetBucketLocation</code>
                </li>
            </ul>
        </React.Fragment>
    );
}

AWSCredentials.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AWSCredentials);
